"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require("react-select");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEPARTMENTS_INIT = window.DEPARTMENTS_INIT || [];
var SEASONS_INIT = window.SEASONS_INIT || [];
var BRAND_DRILLDOWN = window.BRAND_DRILLDOWN || false;

var REPORT_OPTIONS_PARAMETERS = window.REPORT_OPTIONS_PARAMETERS || ["seasons", "departments"];

var DepartmentUpdateOptions = function (_Component) {
    _inherits(DepartmentUpdateOptions, _Component);

    function DepartmentUpdateOptions(props) {
        _classCallCheck(this, DepartmentUpdateOptions);

        var _this = _possibleConstructorReturn(this, (DepartmentUpdateOptions.__proto__ || Object.getPrototypeOf(DepartmentUpdateOptions)).call(this, props));

        _this.state = {
            departments: [],
            seasons: []
        };

        _this.selectOption = _this.selectOption.bind(_this);
        _this.update = _this.update.bind(_this);
        _this.deconstructUrl = _this.deconstructUrl.bind(_this);
        _this.hasChanged = _this.hasChanged.bind(_this);
        _this.renderBrandCol = _this.renderBrandCol.bind(_this);
        _this.renderDepartmentCol = _this.renderDepartmentCol.bind(_this);
        return _this;
    }

    _createClass(DepartmentUpdateOptions, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.deconstructUrl();
        }
    }, {
        key: "deconstructUrl",
        value: function deconstructUrl() {
            var state = {
                departments: [],
                seasons: []
            };

            location.search.slice(1).split("&").forEach(function (part) {
                var _part$split = part.split("="),
                    _part$split2 = _slicedToArray(_part$split, 2),
                    key = _part$split2[0],
                    value = _part$split2[1];

                if (typeof state[key.slice(0, key.length - 2)] === "undefined") return;

                state[key.slice(0, key.length - 2)].push({ value: decodeURIComponent(value), label: decodeURIComponent(value) });
            });

            state.initialState = _extends({}, state);

            this.setState(state);
        }
    }, {
        key: "selectOption",
        value: function selectOption(key) {
            var _this2 = this;

            return function (values) {
                _this2.setState(_defineProperty({}, key, values));
            };
        }
    }, {
        key: "update",
        value: function update() {
            var _state = this.state,
                departments = _state.departments,
                seasons = _state.seasons;


            var ds = departments.map(function (d) {
                return "departments[]=" + encodeURIComponent(d.value);
            }).join("&");
            var ss = seasons.map(function (d) {
                return "seasons[]=" + encodeURIComponent(d.value);
            }).join("&");

            var queryString = ds + (ds && ss ? "&" : "") + ss;

            location.href = location.origin + location.pathname + "?" + queryString;
        }
    }, {
        key: "hasChanged",
        value: function hasChanged() {
            var _state2 = this.state,
                departments = _state2.departments,
                seasons = _state2.seasons,
                initialState = _state2.initialState;


            if (!initialState) return false;

            return JSON.stringify({ departments: departments, seasons: seasons }) !== JSON.stringify(initialState);
        }
    }, {
        key: "renderBrandCol",
        value: function renderBrandCol() {
            return _react2.default.createElement(
                "div",
                { className: "options-col" },
                _react2.default.createElement(
                    "label",
                    null,
                    "Brand"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "value" },
                    BRAND.name
                )
            );
        }
    }, {
        key: "renderDepartmentCol",
        value: function renderDepartmentCol() {
            if (REPORT_OPTIONS_PARAMETERS.indexOf("departments") === -1) return null;

            var departments = this.state.departments;

            return _react2.default.createElement(
                "div",
                { className: "options-col" },
                _react2.default.createElement(
                    "label",
                    null,
                    "Department"
                ),
                _react2.default.createElement(_reactSelect2.default, { options: DEPARTMENTS_INIT, value: departments || false, onChange: this.selectOption("departments"), multi: true, placeholder: "Select department..." })
            );
        }
    }, {
        key: "renderSeasonsCol",
        value: function renderSeasonsCol() {
            if (REPORT_OPTIONS_PARAMETERS.indexOf("seasons") === -1) return null;

            var seasons = this.state.seasons;

            return _react2.default.createElement(
                "div",
                { className: "options-col" },
                _react2.default.createElement(
                    "label",
                    null,
                    "Season"
                ),
                _react2.default.createElement(_reactSelect2.default, { options: SEASONS_INIT, value: seasons || false, onChange: this.selectOption("seasons"), multi: true, placeholder: "Select season..." })
            );
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "department-update-options" },
                _react2.default.createElement(
                    "div",
                    { className: "options-cols" },
                    BRAND_DRILLDOWN ? this.renderBrandCol() : this.renderDepartmentCol(),
                    this.renderSeasonsCol()
                ),
                _react2.default.createElement(
                    "div",
                    { className: "ix-update rwi-btn-rounded rwi-btn-" + (this.hasChanged() ? "success" : "neutral"), onClick: this.update },
                    "Update"
                )
            );
        }
    }]);

    return DepartmentUpdateOptions;
}(_react.Component);

exports.default = DepartmentUpdateOptions;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/reports/DepartmentUpdateOptions.js
// module id = 519
// module chunks = 0